import {useEffect} from 'react'
import {KTSVG} from '../../../_ePulse/helpers'
import {useNavigate} from 'react-router-dom'
import '../../../App.css'
import {MenuComponent} from '../../../_ePulse/assets/ts/components'
import {useGetDateTimeFormat} from '../../../data/config'
export const ClinicListTable = (props: any) => {
  const navigate = useNavigate()

  useEffect(() => {
    MenuComponent.reinitialization() // import from _metronic/assets/ts/components
  }, [])

  return (
    <>
      <div className='dashboard-table-row '>
        <div className='d-flex  align-items-center col-2'>
          <div className='d-flex flex-column me-2 '>
            <div className='d-flex flex-stack '>
              <span className='col-value text-truncate' style={{maxWidth: '150px'}}>
                {props.clinic.businessName}
              </span>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column me-2 col-2  justify-content-center'>
          <div className='d-flex flex-stack'>
            <span className='col-value text-truncate' style={{maxWidth: '150px'}}>
              {props.clinic.systemRole || 'NA'}
            </span>
          </div>
        </div>

        <div className='d-flex flex-column me-2 col-2 justify-content-center'>
          <div className='d-flex flex-stack'>
            <span className='col-value text-truncate' style={{maxWidth: '150px'}}>
              {props.clinic.firstName} {props.clinic.lastName}
            </span>
          </div>
        </div>

        <div className='d-flex flex-column me-2 col-2 justify-content-center'>
          <div className='d-flex flex-stack'>
            <span className='col-value text-truncate' style={{maxWidth: '150px'}}>
              {props.clinic.businessPhone}
            </span>
          </div>
        </div>
        <div className='d-flex flex-column me-2 col-2 justify-content-center'>
          <div className='d-flex flex-stack'>
            <span className='col-value text-truncate' style={{maxWidth: '150px'}}>
              {useGetDateTimeFormat(props.clinic.createdDate)}
            </span>
          </div>
        </div>

        <div className='d-flex flex-row me-2 col-2 justify-content-center '>
          <div className='d-flex flex-row align-items-center justify-content-center'>
            <button
              onClick={() =>
                navigate('/business/view', {
                  state: {
                    clinicId: props?.clinic?.businessId,
                    userId: props?.clinic?.userId,
                  },
                })
              }
              className='menu-link px-3 text-dark border-0 bg-white fw-semibold'
            >
              <KTSVG path='/media/ePulse/view_icon.svg' className='m-0' />
            </button>
          </div>
          <div className='d-flex flex-row align-items-center justify-content-center'>
            <button
              onClick={() =>
                navigate('/business/edit', {
                  state: {clinicId: props?.clinic?.businessId, id: props?.clinic?.id},
                })
              }
              className='menu-link px-3 text-dark border-0 bg-white fw-semibold'
            >
              <KTSVG path='/media/ePulse/edit_icon.svg' className='m-0' />
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
